//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CurrentDialog from "./CurrentDialog";
export default {
  name: "RightTable",
  props: {
    current: {
      type: Object,
      default: {},
    },
  },
  components: {
    CurrentDialog,
  },
  data() {
    return {
      personList: [], // 业务员列表
      showDialog: false, // 弹窗展示
      dialogObj: {}, // 弹框类型
      // 弹窗信息
      handles: {
        add: { label: "添加业务员", id: 8, w: "500px", btn: "确认" },
        delete: { label: "删除业务员", id: 10, w: "400px", btn: "删除" },
      },
      multipleSelection: [], // 表格选中
      businessZoneList: [], // 区域列表
    };
  },
  methods: {
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 获取业务员列表
     * @Author: yangsibo
     * @Date: 2022-05-12 14:35:20
     * @param {*} id 区域id
     * @return {*}
     */
    async getPersonListbyZoneId(id) {
      try {
        let { data } = await this.$http.business.getPersonListbyZoneId({
          businessZoneId: id,
        });
        this.personList = data ? data : [];
      } catch (error) {}
    },
    /**
     * @description: 批量添加业务员
     * @Author: yangsibo
     * @Date: 2022-05-12 15:50:48
     */
    addPerson() {
      this.handleDialog(this.handles.add);
    },
    /**
     * @description: 批量删除业务员
     * @Author: yangsibo
     * @Date: 2022-05-12 15:50:48
     */
    deletePerson() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请至少选中一个业务员",
          duration: 2000,
        });
        return;
      }
      this.handleDialog(this.handles.delete);
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-05-13 17:42:26
     */
    handleDialog(item) {
      this.dialogObj = item;
      this.showDialog = true;
    },
  },
  created() {},
  mounted() {},
  watch: {
    current: {
      handler(val) {
        if (val) {
          this.getPersonListbyZoneId(val.id);
        }
      },
      deep: true,
    },
  },
};
